<form
  autocomplete="off"
  class="bn-search"
  data-e2e="LayoutSearchForm"
  [formGroup]="form">
  <div
    data-e2e="LayoutSearchInputWrapper"
    (click)="onInputClick()">
    <bn-web-ui-input
      borderRadius="lg"
      data-e2e="LayoutSearchTerm"
      formControlName="searchTerm"
      size="xs"
      [itemStyle]="form.controls.searchTerm.value ? 'primary' : 'secondary'"
      [loading]="isLoading"
      [options]="{
        removePadding: true,
        leftAddons: leftInputAddons,
        rightAddons: !isLoading ? rightInputAddons : [],
      }"
      [placeholder]="placeholder"
      (clickAction)="onAddonClick($event)" />
  </div>
  @if (isOpen) {
    <ng-content />
  }
</form>
